module.exports = __webpack_public_path__ + "img/medicaling.ba1c6c39.png";